import React, { useEffect, useState, useContext } from 'react';
import UserContext from "../context/UserContext";
import { api } from '../utils/apiHelper';
import '../styles/BidOffer.css';

const BidOffer = () => {
  const { authUser } = useContext(UserContext);
  const [offers, setOffers] = useState([]);

  useEffect(() => {
    fetchOffers();
  }, []);

  const fetchOffers = async () => {
    try {
      const res = await api('/get-all-offers', 'GET');
      if (res.success) {
        setOffers(res.allOffers);
      }
    } catch (err) {
      console.error('Error fetching offers:', err.message);
    }
  };

  const handleApprove = async (shortCode, offerIndex, offer) => {
    try {
      const res = await api('/approve-offer', 'POST', {
        shortCode,
        offerIndex,
        email: offer.email,
        amount: offer.amount,
      });

      if (res.success) {
        alert('Offer approved');
        fetchOffers();
      } else {
        alert('Failed to approve offer');
      }
    } catch (err) {
      console.error('Approval error:', err.message);
    }
  };

  const handleClose = async (shortCode) => {
    const confirmed = window.confirm("Close this item for further offers?");
    if (!confirmed) return;

    try {
      const res = await api('/close-bid-item', 'POST', { shortCode });
      if (res.success) {
        alert('Item closed');
        fetchOffers();
      } else {
        alert('Failed to close item');
      }
    } catch (err) {
      console.error('Error closing item:', err.message);
    }
  };

  return (
    <div className="bid-offer-container">
      <h3>Bid Offers</h3>
      {offers.length === 0 ? (
        <p>No offers available.</p>
      ) : (
        offers.map((item, idx) => (
          <div key={idx} className="bid-offer-card">
            <h4>{item.title} <span className="short-code">({item.shortCode})</span></h4>

            <p className="status-label">
              {item.closed ? '🛑 Sale Closed' : '🟢 Open for Offers'}
            </p>

            {!item.closed && (
              <button
                className="close-sale-button"
                onClick={() => handleClose(item.shortCode)}
              >
                Close Sale
              </button>
            )}

            <ul>
              {item.offers.map((offer, i) => (
                <li key={i}>
                  <strong>{offer.username || 'Unknown User'}:</strong> ${offer.amount}
                  {offer.status === 'approved' ? (
                    <span className="approved-label">
                      ✅ Approved {item.closed && '• Sale Closed'}
                    </span>
                  ) : (
                    <button
                      onClick={() => handleApprove(item.shortCode, i, offer)}
                      className="approve-button"
                      disabled={item.closed}
                    >
                      Approve
                    </button>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))
      )}
    </div>
  );
};

export default BidOffer;
